import {z} from 'zod'
import {PaymentRange} from 'types/PaymentRange'
import {PaymentRangeGraphType} from 'types/PaymentRangeGraphType'

////////////////////////////////////////////////////////////////////////////////

export const chartPreferencesSchema = z.object({
  statsGraphType: z.enum(PaymentRangeGraphType),
  statsRange: z.enum(PaymentRange),
})
export type ChartPreferences = z.infer<typeof chartPreferencesSchema>
